import React, { useContext } from 'react';
import classNames from 'classnames';
import FieldRequiredVisibleInfo from 'components/FieldRequiredVisibleInfo';
import { ListingRequiredVisibleInfo } from 'models/Listing';
import { FieldRequiredVisibleInfoProps } from 'components/FieldRequiredVisibleInfo/FieldRequiredVisibleInfo.component';
import ListingFieldsRequiredVisibleInfoContext from '../../providers/ListingFieldsRequiredVisibleInfo/ListingFieldsRequiredVisibleInfo.context';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './ListingFieldRequiredVisibleInfo.styles.scss';

type ListingFieldRequiredVisibleInfoProps = {
  fieldName: keyof ListingRequiredVisibleInfo;
  canChangeRequired?: boolean;
} & Omit<
  FieldRequiredVisibleInfoProps,
  'canChangeRequired' | 'fieldValue' | 'onSubmit'
>;

const ListingFieldRequiredVisibleInfo: React.FC<
  ListingFieldRequiredVisibleInfoProps
> = (props) => {
  const { className, fieldName, canChangeRequired = true, ...rest } = props;

  const { isSuperAdmin } = useContext(CurrentUserContext);
  const {
    fields,
    canChangeRequired: globalCanChangeRequired,
    updateField,
  } = useContext(ListingFieldsRequiredVisibleInfoContext);

  const classes = classNames('listing-field-required-visible-info', className);

  if (!isSuperAdmin) return null;

  return (
    <FieldRequiredVisibleInfo
      className={classes}
      canChangeRequired={canChangeRequired && globalCanChangeRequired}
      fieldValue={fields?.[fieldName]}
      onSubmit={(values, onSuccess) =>
        updateField(fieldName, values, onSuccess)
      }
      {...rest}
    />
  );
};

export default ListingFieldRequiredVisibleInfo;
